import { render, staticRenderFns } from "./BibliomapHybrid.vue?vue&type=template&id=8bff3566&"
import script from "./BibliomapHybrid.vue?vue&type=script&lang=js&"
export * from "./BibliomapHybrid.vue?vue&type=script&lang=js&"
import style0 from "./BibliomapHybrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports